import { render, staticRenderFns } from "./fallbackInitiativesDisplay.vue?vue&type=template&id=6dca749d"
import script from "./fallbackInitiativesDisplay.vue?vue&type=script&lang=js"
export * from "./fallbackInitiativesDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports